import * as THREE from 'three'

export const getLineMaterial = (
  { color, linewidth = 1, opacity = 1 },
  materials
) => {
  const id = `${color}:${opacity}`
  if (!materials.line[id]) {
    materials.line[id] = new THREE.LineBasicMaterial({
      color,
      linewidth,
      opacity,
      transparent: opacity !== 1
    })
  }
  return materials.line[id]
}
